<template>
  <div class="choice">
    <div class="choiceItem">
      <div class="choiceTitle">
        【填空题】
        <span class="score">（本题{{ data.score }}分）</span>
      </div>
      <div class="testName">
        {{ num + 1 }}.
        <div class="name" v-html="data.questionName"></div>
      </div>
      <div class="tinymceWrap">
        <div
          class="tinymce"
          v-for="(choiceItem, choiceIndex) in data.optionList"
          :key="choiceItem.optionId"
        >
          <div class="numChoice">
            填空{{ ["一", "二", "三", "四", "五", "六", "七"][choiceIndex] }}
          </div>
          <tinymce
            ref="editor"
            v-model="choiceItem.answer"
            @eventHandle="standardSlotChange"
          ></tinymce>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Tinymce from "@/components/Tinymce";
export default {
  components: {
    Tinymce,
  },
  props: {
    data: {
      type: Object,
      default: () => ({}),
    },
    allArr: {
      type: Array,
      default: () => [],
    },
    num: {
      type: Number,
      default: null,
    },
  },
  data() {
    return {
      single: [],
      multiple: [],
      shortAnswer: [],
    };
  },
  mounted() {},
  methods: {
    standardSlotChange() {
      // console.log(val);
    },
  },
};
</script>

<style scoped lang="scss">
.choice {
  .active {
    background-color: #3671bf !important;
    color: #ffffff !important;
  }
  .tinymceWrap {
    // max-height: 670px;
    // overflow-y: auto;
    .tinymce {
      display: flex;
      margin-bottom: 30px;
      &:last-child {
        margin-bottom: 0;
      }
      .numChoice {
        width: 80px;
        font-size: 16px;
        font-family: Source Han Sans CN-Regular, Source Han Sans CN;
        font-weight: 400;
        color: #666666;
        margin-right: 16px;
      }
    }
  }

  .choiceItem {
    .choiceTitle {
      font-size: 16px;
      font-family: Source Han Sans CN-Bold, Source Han Sans CN;
      font-weight: bold;
      color: #3671bf;
      .score {
        color: #909399;
      }
    }

    .testName {
      display: flex;
      font-size: 18px;
      font-family: SourceHanSansCN-Regular-, SourceHanSansCN-Regular;
      font-weight: normal;
      color: #333333;
      margin-top: 30px;
      margin-bottom: 24px;
      .name {
        margin-left: 10px;
        width: 100%;
        height: auto;
      }
    }
    .optionChoice {
      display: flex;
      align-items: center;
      width: 100%;
      .optionTag {
        width: 28px;
        line-height: 28px;
        background: #ffffff;
        border: 1px solid #d8dee6;
        text-align: center;
        border-radius: 50%;
        margin-right: 10px;
      }
      .optionName {
        width: calc(100% - 38px);
        height: auto;
      }
    }
    ::v-deep .is-checked {
      .optionTag {
        background-color: #3671bf !important;
        color: #fff !important;
      }
    }
  }
  ::v-deep .el-radio-group {
    .el-radio__input {
      display: none;
    }
    .el-radio__label {
      font-size: 14px;
      font-family: Source Han Sans CN-Regular, Source Han Sans CN;
      font-weight: 400;
      color: #545454;
      line-height: 14px;
    }
    .el-radio {
      width: 100%;
    }
  }
  ::v-deep .el-checkbox-group {
    .el-checkbox {
      display: block;
    }
    .el-checkbox__inner {
      display: none;
    }
    .el-checkbox__label {
      font-size: 14px;
      font-family: Source Han Sans CN-Regular, Source Han Sans CN;
      font-weight: 400;
      color: #545454;
      line-height: 14px;
    }
    .el-checkbox {
      width: 100%;
      margin-bottom: 16px;
    }
  }
}
</style>
